import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanBEApi } from "~/Services";

interface DocumentDetailsResponse {
  id: number;
  name: string;
  enquiryType: string;
  email: string;
  mobile: string;
  message: string;
  submittedAt: string;
  viewedAt: string;
  replyMessage: string;
  replyAt: string;
  category: string;
}

// edit api call
const fetchEnquiriesDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await eramanBEApi.get(`/admin/enquiries/get?id=${id}`);
  return response.data;
};

const useEnquiriesDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["enquiriesDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchEnquiriesDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useEnquiriesDocumentDetails };
